// LiveStreamAsideTopPanel.js
'use strict';
import { connect } from 'react-redux';

import LiveStreamAsideTopPanel from '../component/LiveStreamAsideTopPanel.jsx';
import getOperationData from '../selector/getOperationData.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import { getHasStreamToken } from '../selector/getLivestreamComputedData.js';
import setLiveStreamPanel from '../action/setLiveStreamPanel.js';
import { ExclusivePrivateStatus } from '../resource/liveStreamConstants.js';

const mapStateToProps = (state, { streamId }) => {
  const streamStatus = getLiveStreamData(state, [streamId], 'status');
  const hasStreamToken = getHasStreamToken(state, streamId);
  const exclusivePrivateStatus = getLiveStreamData(
    state,
    [streamId, 'exclusivePrivate'],
    'status'
  );
  return {
    streamStatus,
    hasStreamToken,
    isAsideTopPanelExpanded: getOperationData(
      state,
      ['liveStream', 'panel'],
      'isAsideTopPanelExpanded'
    ),
    isExclusivePrivateOngoing: [
      ExclusivePrivateStatus.PERFORMING,
      ExclusivePrivateStatus.PREPARING,
    ].includes(exclusivePrivateStatus),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setLiveStreamPanel: ({ ...data }) =>
      dispatch(setLiveStreamPanel({ ...data })),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LiveStreamAsideTopPanel);
